import clsx from 'clsx';
import { usersRoutes } from 'constants/navigation';
import { UserFragment } from 'generated/graphql';
import { Tag, TagColor, TagSize } from '@spotted-zebra-uk/ui-components';
import styles from './UserWithLink.module.scss';

const ROLES_FOR_SZ_TAG = ['admin', 'sz_super_admin'];

const UserWithLink = ({ user }: { user: UserFragment }) => {
    const isSZAdmin = user.roles.some(
        role => ROLES_FOR_SZ_TAG.includes(role.companyRole.role.name)
    );

  return (
    <div className={clsx(styles.container, isSZAdmin && styles.szAdmin)}>
      {isSZAdmin ? (
        <Tag
          size={TagSize.LARGE}
          tagColor={TagColor.DISABLED}
          isDismissible={false}
          isPresentational
          containerClass={styles.szAdminTag}
        >
          SZ
        </Tag>
      ) : null}
      <a
        className={styles.linkToUser}
        href={usersRoutes.user.url(user.id)}
        target="_blank"
        rel="noopener noreferrer"
      >{`${user.firstName} ${user.lastName}`}</a>
    </div>
  );
};

export default UserWithLink;
